import React from 'react';
import { MdIosShare, MdMail } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import EventTicketActionButton from './components/EventTicketActionButton';
import { useEventPageContext } from './context/EventPageContext';

const GuestActions: React.FC = () => {
  const { t } = useTranslation(['events']);
  const {
    toggleViewContactsModal,
    toggleShareModal,
    canShare,
    isLoggedIn,
    event,
    priceRangeNoDiscount,
    setIsTicketModalOpen,
    toggleCheckout
  } = useEventPageContext();

  return (
    <div className="w-full fixed left-0 bottom-0 bg-white pb-8 z-50 md:pb-4 shadow-primary-50 shadow-top md:shadow-none">
      <div className="flex items-center justify-between flex-1 gap-5">
        <EventTicketActionButton
          event={event}
          priceRangeNoDiscount={priceRangeNoDiscount}
          setIsTicketModalOpen={setIsTicketModalOpen}
          toggleCheckout={toggleCheckout}
        />
      </div>

      <div className="md:w-[630px] md:mx-auto flex items-center justify-between pt-4 px-4">
        <div className="flex items-center justify-between flex-1 gap-5">
          {canShare && (
            <Button
              type={ButtonType.Inverted}
              onClick={toggleShareModal}
              icon={<MdIosShare size={20} />}
            >
              {t('events:actions.shareEvent')}
            </Button>
          )}
          {isLoggedIn && (
            <Button
              type={ButtonType.Inverted}
              icon={<MdMail size={20} />}
              onClick={toggleViewContactsModal}
              testId="button-contact-host"
            >
              {t('events:actions.contactHost')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GuestActions;
